import React, { Component } from "react";
import Modal from "@acadia-ui/modal";
import "./modal.scss";
import ModalHelpers from "./ModalHelpers";

const formEl = "missingSiteIdsModal";

class MissingSiteIdsModal extends Component {
	constructor(props) {
		super(props);
		this.state = {};
	}

	componentDidMount() {
		this.props.missingSiteIdsModal(this);
	}

	componentWillUnmount() {
		this.props.missingSiteIdsModal(undefined);
	}

	/* Needed for all Modals */
	triggerOpenClose = (event) => {
		// ModalHelpers.openClose(event, this.updateModalState, this.state);
		this.updateModalState();
	};

	updateModalState = () => {
		Modal.show(formEl);
		this.setState({ open: true });
		// !this.state.open ? Modal.show(formEl) : Modal.hide(formEl);
		// this.setState({ open: !this.state.open });
	};

	render() {
		return (
			<Modal
				id={formEl}
				className={formEl}
				heading={"Missing Site IDs"}
				onRequestClose={() => {
					Modal.hide(formEl);
				}}
				onClick={() => {}}
			>
				<p className="text">
					<ul>
						{this.props.missingSiteIDs.length !== 0
							? [
									<li key="header" className="listHeader">
										Please ensure there is a valid Google Site ID for:{" "}
									</li>,
									...this.props.missingSiteIDs.map((missingSiteID, index) => <li key={index}>{missingSiteID}</li>)
								]
							: []}
					</ul>
				</p>
			</Modal>
		);
	}
}

export default MissingSiteIdsModal;
